import script from "./TicketViewMergeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketViewMergeModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__